"use strict";

var CheckoutStore = require("./CheckoutStore");
var CheckoutApi = require("./CheckoutApi");

var WizardConstants = require("../constants/WizardConstants");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var NumberHelper = require("../shared/NumberHelper");

var DonationUpsellHelper = {
	initializeDonationUpsell: function () {
		var $donationUpsellCheckbox = $("[data-component='donationUpsellCheckbox']");

		$donationUpsellCheckbox.off("click.donationUpsellHelper");
		$donationUpsellCheckbox.on("click.donationUpsellHelper", (event) => {
			//currentTarget is the donationUpsellCheckbox component
			//target can be either donationUpsellCheckbox or donationUpsellCheckbox.input component depending on which was clicked
			var $input = $(event.currentTarget).find("[data-component='donationUpsellCheckbox.input']");
			if (!$(event.target).is($input)) {
				//If the checkbox itself was not clicked, mark it as checked
				$input.prop("checked", !$input.prop("checked"));
			}
			this.handleDonationUpsellChange();
			this._persistDonationUpsellValues(/*didCheckboxChange*/true);
		});

		//If Last-Minute donation was enabled from the cart or saved as checked from session storage, ensure the checkbox is checked
		//	Otherwise, it will use the default from the layout designer.
		if (CheckoutStore.isShoppingCart()) {
			var cartHasDonationUpsell = CheckoutStore.get("cartHasDonationUpsell");
			var isLastMinuteDonationCheckedFromSessionStorage = sessionStorage.getItem("lastMinuteDonationChecked");
			var $donationUpsellCheckbox = $("[data-component='donationUpsellCheckbox.input']");
			var isDonationUpsellCheckboxedByDefault = $donationUpsellCheckbox.prop("checked");

			if (cartHasDonationUpsell != null) { //coercion, want to match null and undefined
				$donationUpsellCheckbox.prop("checked", cartHasDonationUpsell);
			} else if (isLastMinuteDonationCheckedFromSessionStorage != null) { //coercion, want to match null and undefined
				$donationUpsellCheckbox.prop("checked", isLastMinuteDonationCheckedFromSessionStorage === "true");
				//Need to persist this to the cart as well as it was not set in the cart yet.
				this._persistDonationUpsellValues();
			} else if (isDonationUpsellCheckboxedByDefault) {
				//This case is when the checkbox is checked by default on the layout
				//	and it was not specifically set in the cart or in the session
				//	Go ahead and persist to the SE cart now.
				this._persistDonationUpsellValues();
			}
		}

		//Calculating the donation upsell amounts when the page loads
		$(document).ready(() => {
			this.handleDonationUpsellChange();
		})
	},

	checkDonationUpsell: function() {
		if (!this.hasDonationUpsell()) {
			$("[data-component='donationUpsellCheckbox.input']").click();
		}
	},

	getDonationUpsellCalculationValues: function () {
		var calculationType = CheckoutStore.get("wizardDonationUpsell").lastMinuteDonationCalculation;
		var amount = CheckoutStore.get("wizardDonationUpsell").lastMinuteDonationAmount;

		return {
			calculationType,
			amount
		}
	},

	handleDonationUpsellChange: function () {
		if (CheckoutStore.get("isDesignMode")) {
			//Do not do anything in the designer
			return;
		}

		var donationUpsellAmount = 0.0;

		//One-Time
		if (this.hasDonationUpsell()) {
			donationUpsellAmount = this._calculateDonationUpsell(CheckoutStore.getSubtotal());
		}

		//Recurring
		if (CheckoutStore.isShoppingCart()) {
			var donations = CheckoutStore.getCartDonations();
			var recurringDonations = donations.filter(donation => {
				return donation.isRecurring;
			});
			var upsellAmountsByFrequency = {};
			_.values(_.groupBy(recurringDonations, donation => JSON.stringify({
				frequency: donation.frequency,
				category: donation.category,
				source: donation.source,
				startDate: donation.startDate,
				useOnDay: donation.useOnDay
			}))).forEach(groupedRecurringDonations => {
				var totalAmount = 0;
				groupedRecurringDonations.forEach(donation => totalAmount += donation.amount);
			var upsellAmount = this._calculateDonationUpsell(totalAmount);
				upsellAmountsByFrequency[groupedRecurringDonations[0].frequency] = (Number(upsellAmountsByFrequency[groupedRecurringDonations[0].frequency]) || 0) + Number(upsellAmount);
			});

			var $recurringDonations = $("[data-recurring-frequency]");
			$recurringDonations.each((index, recurringDonation) => {
				var $recurringDonation = $(recurringDonation);
				var frequency = $recurringDonation.attr("data-recurring-frequency");
				var recurringDonationUpsellAmount = 0;
				if (this.hasDonationUpsell()) {
					recurringDonationUpsellAmount = upsellAmountsByFrequency[frequency];
				}
				$recurringDonation.attr("upsell-amount", recurringDonationUpsellAmount);
			});
		} else {
			var recurringDonationUpsellAmountForOPCO = 0;
			if (this.hasDonationUpsell()) {
				var recurringTotal = CheckoutStore.getProjectDonationTotalForOPCO();
				recurringDonationUpsellAmountForOPCO = this._calculateDonationUpsell(recurringTotal);
			}

			$("[data-dynamic='AmountForFrequency']").attr("upsell-amount", recurringDonationUpsellAmountForOPCO);
		}

		Dispatcher.dispatch({
			actionType: Constants.DONATION_UPSELL_UPDATE,
			donationUpsellAmount
		});
	},

	hasDonationUpsell: function () {
		var $donationUpsellCheckbox = $("[data-component='donationUpsellCheckbox.input']");
		var isChecked = $donationUpsellCheckbox.prop("checked");

		return isChecked;
	},

	uncheckDonationUpsell: function() {
		if (this.hasDonationUpsell()) {
			$("[data-component='donationUpsellCheckbox.input']").click();
		}
	},

	_persistDonationUpsellValues: function (didCheckboxChange) {
		//Only persist if on the shopping cart page
		//	If on the project page, the checkbox is set in project cached values and sent to the server upon Submit
		if (!CheckoutStore.isShoppingCart()) {
			return;
		}

		//Persist whether it is checked in sessionStorage
		if (didCheckboxChange) {
			if (this.hasDonationUpsell()) {
				sessionStorage.setItem("lastMinuteDonationChecked", "true");
			} else {
				sessionStorage.setItem("lastMinuteDonationChecked", "false");
			}
		}

		//update last-minute donation fields on shopping cart
		var donationUpsellValues = this.getDonationUpsellCalculationValues();

		var lastMinuteDonationAmount = this.hasDonationUpsell() ? donationUpsellValues.amount : null;
		var lastMinuteDonationCalculation = null;
		if (this.hasDonationUpsell()) {
			lastMinuteDonationCalculation = donationUpsellValues.calculationType
		} else if(didCheckboxChange) {
			//The constituent specifically unchecked the checkbox
			lastMinuteDonationCalculation = WizardConstants.LAST_MINUTE_DONATION_CALCULATION_VALUES.CONSTITUENT_DECLINED;
		}

		CheckoutApi.updateLastMinuteDonation(CheckoutStore.getCartType(), {
			lastMinuteDonationCalculation,
			lastMinuteDonationAmount
		});
	},

	_calculateDonationUpsell: function (amount) {
		if (amount <= 0) {
			//If there is no amount, a last minute donation will not be added
			return 0;
		}

		var donationUpsellValues = this.getDonationUpsellCalculationValues();
		var lastMinuteDonationCalculation = donationUpsellValues.calculationType;
		var lastMinuteDonationAmount = donationUpsellValues.amount;

		var upsellAmount = 0.0;

		if (lastMinuteDonationCalculation == WizardConstants.LAST_MINUTE_DONATION_CALCULATION_VALUES.PERCENTAGE) {
			upsellAmount = NumberHelper.roundToTwoDecimals(amount * (lastMinuteDonationAmount / 100));
		}
		if (lastMinuteDonationCalculation == WizardConstants.LAST_MINUTE_DONATION_CALCULATION_VALUES.STATIC_AMOUNT) {
			upsellAmount = NumberHelper.roundToTwoDecimals(lastMinuteDonationAmount);
		}

		return upsellAmount;
	}
};

module.exports = DonationUpsellHelper;
